import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const SpendCreditDialog = ({ open, onOpenChange, user, book, onConfirm }) => {
  const sub = user?.subscription_active || user?.role === "admin";
  const credits = user?.credits || 0;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="spend-credit-dialog" className="bg-navy-950 border-gold-500/20">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl">
            {sub ? "Finish this book?" : "Spend 1 credit to finish this book?"}
          </AlertDialogTitle>
          <AlertDialogDescription className="font-read text-slate-300">
            {book?.title ? <>We'll write the rest of <span className="text-gold-200">{book.title}</span> now. </> : null}
            {sub ? "It's included in your plan." : `You have ${credits} credit${credits === 1 ? "" : "s"}; this uses 1. If writing is interrupted, you can resume it without being charged again.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="spend-credit-cancel">Not now</AlertDialogCancel>
          <AlertDialogAction data-testid="spend-credit-confirm" onClick={onConfirm} className="klyr-btn-metal">
            {sub ? "Finish my book" : "Use 1 credit"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
